var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRemovebgPreview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "500.000000pt",
    height: "500.000000pt",
    viewBox: "0 0 500.000000 500.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,500.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2355 4313 c-553 -45 -1063 -345 -1367 -803 -152 -229 -250 -486 -289 -755 -17 -115 -17 -406 0 -510 72 -452 295 -847 645 -1144 226 -191 523 -329 833 -386 134 -25 412 -31 558 -11 368 48 706 204 981 451 282 253 483 604 566 985 20 93 22 133 23 360 0 230 -2 266 -23 363 -62 285 -195 566 -372 782 -66 80 -199 213 -280 278 -147 118 -379 243 -565 305 -216 71 -486 104 -710 85z m326 -164 c306 -31 606 -153 849 -346 311 -247 512 -573 597 -970 25 -116 27 -146 27 -333 0 -173 -4 -221 -23 -310 -59 -278 -169 -513 -341 -730 -69 -86 -210 -230 -227 -230 -4 0 -17 17 -28 37 -11 21 -45 71 -76 113 -318 430 -858 597 -1361 420 -241 -85 -453 -254 -600 -479 -26 -40 -48 -77 -48 -82 0 -27 -38 2 -126 94 -224 235 -360 477 -435 774 -109 432 -27 927 214 1296 202 309 520 556 857 665 263 86 462 108 721 81z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2330 3365 c-113 -31 -218 -92 -305 -179 -88 -88 -131 -154 -173 -268 -24 -66 -26 -86 -27 -213 0 -126 3 -148 28 -221 94 -280 355 -465 655 -464 171 1 347 75 473 200 131 130 188 261 196 450 6 140 -10 218 -68 339 -72 148 -236 289 -399 343 -85 28 -297 35 -380 13z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRemovebgPreview);
export default __webpack_public_path__ + "static/media/user-removebg-preview.3689358f8734af64dcbb5a842ceb12d8.svg";
export { ForwardRef as ReactComponent };